module.exports = __webpack_public_path__ + "static/media/sirius-logo.50d24cd1.svg";